<template>
<div class="wrap">
    <wedHd></wedHd>
    <div class="hed_img">
        <img src="@/assets/images/wap/5Gwap.png" alt="">
    </div>

<!-- <div class="wepTex">
    <div class="title">彩讯5G新消息平台</div>
    <div class="text">彩讯5G新消息平台是连接行业客户与底层消息中心，通过对内容、消息、任务的综合管理实现5G消息的场景化下发，助力行业客户实现消息场景升级。</div>
</div> -->

<div class="contentBox contentProducts">
    <div class="titleBox">产品服务</div>

    <ul class="coreWrap">
        <li>
            <img src="@/assets/images/wap/pro1.png" alt="">
            <p>聚焦垂直行业</p>
        </li>
        <li>
            <img src="@/assets/images/wap/pro2.png" alt="">
            <p>高并发易接入</p>
        </li>
        <li>
            <img src="@/assets/images/wap/pro3.png" alt="">
            <p>兼容覆盖短彩</p>
        </li>
    </ul>
</div>

<div class="productionBox">
    <div class="hTitle">5G消息制作与发送</div>
    <div class="h3Box">
        <div class="chileTitle">1.场景化消息下发</div>
        <div class="content">面向不同场景提供多种消息下发方式，如：标准群发、个性化推送和会话式消息。</div>
        <img src="@/assets/images/wap/himg1.png" alt="">
    </div>


    <div class="h3Box">
        <div class="chileTitle">2.行业模板库</div>
        <div class="content">海量行业模板支持一键导入使用，方便快捷。</div>
        
    </div>

    <ul class="ulBOx">
        <li><img src="@/assets/images/wap/introduceBTypeBIcon2.png" alt=""></li>
        <li><img src="@/assets/images/wap/introduceBTypeBIcon10.png" alt=""></li>
    </ul>
    <div class="h3Box">
        <div class="chileTitle">3.三级回落机制</div>
        <div class="content">提供多种短信兼容方案，可回落成up1.0或短信，以及回落成短信小程序和视频短信。</div>
        
    </div>
</div>


<div class="productionBox productionBoxThree">
    <div class="hTitle">垂直行业chatbot</div>
    <div class="h3Box">
        <div class="chileTitle">1.接入方案</div>   
    </div>
    <ul class="coreWrap">
        <li>
            <img src="@/assets/images/wap/chatbot01.png" alt="">
            <p>定制化接入</p>
            <p>客户自有chatbot</p>
        </li>
        
        <li>
            <img src="@/assets/images/wap/chatbot02.png" alt="">
            <p>平台版</p>
            <p>标准化chatbot</p>
        </li>
    </ul>
    <div class="h3Box">
        <div class="chileTitle">2.行业知识图谱</div>   
    </div>
    <div class="conBg">
        <img src="@/assets/images/wap/forImgBg.png" alt="">
    </div>
    <div class="h3Box">
        <div class="chileTitle">3.闲聊库</div>   
    </div>
    <div class="conBg" style="width:297px;height:224px">
        <img src="@/assets/images/wap/forImgCon.png" alt="">
    </div>
    <div class="h3Box">
        <div class="chileTitle">4.NLP</div>   
    </div>
    <div class="conBg" style="width:345px;height:319px">
        <img src="@/assets/images/wap/nlp.png" alt="">
    </div>
</div>


<div class="contentBox contentList">
    <div class="titleBox">增值服务</div>

    <ul class="coreWrap">
        <li>
            <img src="@/assets/images/wap/increment01.png" alt="">
        </li>
        <li>
            <img src="@/assets/images/wap/increment02.png" alt="">
        </li>
        <li>
            <img src="@/assets/images/wap/increment03.png" alt="">
        </li>
        <li>
            <img src="@/assets/images/wap/increment04.png" alt="">
        </li>
        <li>
            <img src="@/assets/images/wap/increment05.png" alt="">
        </li>
        <li>
            <img src="@/assets/images/wap/increment06.png" alt="">
        </li>
        <li>
            <img src="@/assets/images/wap/increment07.png" alt="">
        </li>
        <li>
            <img src="@/assets/images/wap/increment08.png" alt="">
        </li>

    </ul>
</div>

<div class="contentBox contentList">
    <div class="titleBox">多种可接入方式</div>
    <div class="itemBox">
        <img src="@/assets/images/wap/item01.png" alt="">
    </div>
    <div class="itemBox">
        <img src="@/assets/images/wap/item02.png" alt="">
    </div>
        <div class="itemBox">
        <img src="@/assets/images/wap/item03.png" alt="">
    </div>
        <div class="itemBox">
        <img src="@/assets/images/wap/item04.png" alt="">
    </div>
</div>


  <wedFt></wedFt>
 <!-- <div class="footBtn">
     <img src="@/assets/images/wap/footLogo.png" alt="">
     <p>版权所有 © 彩讯科技股份有限公司.All right reserved</p>
     <p>粤ICP备15050890号-2</p>
 </div> -->
</div>
</template>

<script>
import wedHd from '@/components/wepHearder.vue'
import wedFt from '@/components/wefot.vue'

export default {
    components:{
        wedHd,
        wedFt,
    },
    name: 'wapHome',
    data(){
        return{
            'photo-o':'@/assets/images/wap/banner1.png',
            show: false
            // actions: [{ name: '选项一' }, { name: '选项二' }, { name: '选项三' }],
        }
    },
    methods:{
        moses(val){
            console.log(val)
        },
        onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.show = false;
      Toast(item.name);
    }
    },
    
    
}
</script>
<style scoped>

img{
    width: 100%;
}
.itemBox{
    width: 100%;
    height: 240px;
}
.contentList .coreWrap li img{
    width: 186px;
    height: 151px;
}
.conBg{
    width: 336px;
    height: 159px;
    margin: 0 auto;
}
.productionBoxThree .coreWrap{
    display: flex;
    justify-content: space-between;
}
.productionBoxThree .coreWrap  li{
    display: flex;
    flex-direction: column;
    text-align: center;
}
.productionBoxThree .coreWrap  li P:first-child{
    font-size: 15px;
    color: #1C2A39;
    padding-bottom: 10px;
}
.productionBoxThree .coreWrap  li P:last-child{
    font-size: 12px;
    color: #4D5865;
}
.productionBoxThree .coreWrap  li:first-child{
    border-right: 1px solid #D8DADD;
}
.productionBoxTow{

}
.productionBox .ulBOx{
    display: flex;
    justify-content: space-between;
    padding: 20px 0;
}
.productionBox .ulBOx li{
    
    flex: 12;
    padding: 5px;
}
.productionBox .ulBOx li img{
    width: 100%;
}
.productionBox{
    width: 100%;
    height: auto;
    margin-top: 10px;
    color: #1C2A39;
    font-size: 20px;
    background: url(../../assets/images/wap/title.png) no-repeat left top #fff;
    background-size: 29px;
    padding-left: 15px;
    border-bottom: 1px solid #EDEEF0;
    padding: 30px 20px;
}
.productionBox .hTitle{
    font-size: 24px;
    color: #1C2A39;
    letter-spacing: 0;
    font-weight: 400;
    margin: 10px 0;
}
.productionBox .h3Box{
    padding: 0px 0;
}
.productionBox .h3Box img{
    width: 318px;
    height: 289px;
    margin: 20px 0;
}
.productionBox .h3Box .chileTitle{
    font-size: 18px;
    color: #1C2A39;
    letter-spacing: 0;
    font-weight: 700;
    margin: 20px 0;
}
.productionBox .h3Box .content{
    font-size: 15px;
    color: #4D5865;
    letter-spacing: 1px;
    text-align: justify;
    line-height: 24px;
    font-weight: 400;
}
/* 产品服务Start */
.contentProducts{
    margin-top: 0!important;
}
.contentProducts .coreWrap{
    display: flex;
    justify-content: space-between;
}
.contentProducts .coreWrap li{
    text-align: center;
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
}
.contentProducts .coreWrap li img{
    width: 49px;
    height: 43px;
    margin: 0 auto;
}
.contentProducts .coreWrap li p{
    color: #4D5865;
    font-size: 13px;
    padding: 10px 0;
}
/* 产品服务End */
/* 底部黑色背景列表内容Start */
.footBtn{
    padding: 10px 20px;
    box-sizing: border-box;
    background: #2A2B2C;
}
.footBtn img{
    width: 100%;
    height: 43px;
}
.footBtn p{
    color: #F4F5F6;
    line-height: 25px;
    font-size: 12px;
    margin-top: 10px;
}
.van-cell::after{
    display: none;
}
.van-cell__right-icon{
    color: #fff;
}
.van-cell{
    background: none;
    color: #fff;
}
.navwrap{
    position: relative;
    z-index: 999;
    background: #2A2B2C;
    padding-top:10px;
    border-bottom: 1px solid #5C5D5E;
}
/* 底部黑色背景列表内容End */

.contentList{

}
.contentList .coreWrap{
    display: flex;
    flex-wrap: wrap;
    margin-top: 5px;
}
.contentList .coreWrap li{
    background-color: #fff;
    border:1px solid #EDEEF0;
    width: 50%;
    box-sizing: border-box;
    text-align: center;
    /* height: 276px; */
    line-height: 276px;
    padding: 0;
}
/* .contentList .coreWrap li img{
    width: 188px;
    height: 171px;
} */
.coreWrap{
    background-color: #fff;
}
.coreWrap li{
    padding: 22px 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
}
.coreWrap li .comTex{
    flex: 1;
    margin-right: 20px;
}
.coreWrap li .comTex .title{
    color: #1C2A39;
    font-size: 16px;

}
.coreWrap li .comTex .texts{
    color: #4D5865;
    font-size: 12px;
    margin-top: 8px;
    line-height:20px;

}
.coreWrap li .conImg{
    width: 105px;
    height: 80px;
}
.coreWrap li .conImg img{
    width: 100%;
}
.wrap{
    background: #f4f5f6;
}
.vieHead{
    width: 100%;
    height: 50px;
    padding: 0 10px 0 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.wapLogo{
    width: 136px;
    height: 36px;
}
.wapLogo img,.wapmore img{
    width: 100%;
}
.wapmore{
    width: 25px;
    height: 25px;
}
.my-swipe img {

}
.wepTex{
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    /* margin: 35px 0; */
    /* margin-bottom: 10px; */
    background: #fff;
}
.wepTex .title{
    color: #1C2A39;
    font-size: 24px;
    padding: 20px 0;

}
.wepTex .text{
    color: #4D5865;
    font-size: 13px;
    line-height: 22px;

}
.contentBox{
    background: #fff;
    margin-top: 10px;
}
.titleBox{
    width: 100%;
    height: 58px;
    line-height: 58px;
    color: #1C2A39;
    font-size: 20px;
    background: url(../../assets/images/wap/title.png) no-repeat left top;
    background-size:29px;
    padding-left: 15px;
    /* border-bottom: 1px solid #EDEEF0; */
}
</style>


// WEBPACK FOOTER //
// src/pages/wapProducts/index.vue